<div class="fx-fill fx-layout-col">
  <div class="sheet-header">
    <div class="fx-layout-row fx-justify-start fx-align-baseline">
      <div class="sheet-title fx-flex-85-percent">
        <span>{{ project?.toString() }}</span>
      </div>
      <div class="fx-flex-48">
        <div class="btn-container">
          <button (click)="closeProjectSidePanel()" [disableRipple]="true"
                  id="close-sheet-button" mat-icon-button>
            <mat-icon fontSet="mdi" fontIcon="mdi-close" class="sm"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="fx-layout-row">
      <restricted-icon-button
        (onClick)="uploadProjectDocuments()"
        icon="mdi-paperclip"
        iconClass="sm"
        [id]="'upload-project-document-button'"
        [matTooltip]="'BUTTON.ADD_DOCUMENT' | translate"
        [permissions]="[Permission.EDIT_PROJECT, Permission.CREATE_DOCUMENT]">
      </restricted-icon-button>
      <restricted-icon-button
        (onClick)="deleteProject()"
        icon="mdi-delete"
        iconClass="sm"
        [id]="'delete-project-button'"
        [matTooltip]="'BUTTON.DELETE' | translate"
        [permissions]="[Permission.DELETE_PROJECT]"
        [preconditions]="preconditionForDeletion">
      </restricted-icon-button>
      <workflow-buttons
        [entityType]="EntityType.PROJECT"
        [view]="ManualWorkflowViewEnum.SIDEPANEL"
        [selectedEntityIds]="[project?.id]">
      </workflow-buttons>

      <span class="fx-flex"></span>

      <div class="sheet-link">
        <span (click)="navigateToProjectSheet()">{{ 'BUTTON.SHOW_PROJECT_SHEET' | translate }}</span>
      </div>
    </div>
  </div>
  <div cdk-scrollable class="sidebar-sheet fx-flex-grow">
    <div class="page-sidebar">
      <div class="form-container">
        @if (project) {
          <form-builder
            [formId]="formId"
            [displayHeader]="false"
            [eventsOrigin]="eventsOrigin"
            [permissionsForEdition]="permissionsForEdition">
          </form-builder>
        }
      </div>
      <div class="document-title fx-layout-row fx-justify-start fx-align-center">
        <span class="fx-flex-30-percent"> {{ 'LABEL.DOCUMENT' | translate }} </span>
        <restricted-text-button
          (onClick)="uploadProjectDocuments()"
          [id]="'projects-upload-document-button'"
          [permissions]="[Permission.EDIT_PROJECT, Permission.CREATE_DOCUMENT]"
          class="btn-upload-document">
          {{ 'BUTTON.ADD_DOCUMENT' | translate }}
        </restricted-text-button>
      </div>
      @for (document of project?.documents; track document) {
        <div class="document-content">
          @if (accessManager.hasAccess(Permission.EXPORT_DOCUMENT)) {
            <a (click)="downloadProjectDocument(document.id)">
              <mat-icon fontSet="mdi" fontIcon="mdi-file-outline" class="xs"></mat-icon>
              <span class="file-name-label">{{ document.name }}</span>
            </a>
          } @else {
            <span class="file-name-label">{{ document.name }}</span>
          }
          <span (click)="deleteProjectDocument(document)"
                [permission-lock]="[Permission.EDIT_PROJECT, Permission.DELETE_DOCUMENT]" class="delete-document-icon">
            <mat-icon fontSet="mdi" fontIcon="mdi-delete" class="xs"></mat-icon>
          </span>
        </div>
      }
    </div>
  </div>
</div>
